import { Button, Spin, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";

import RecipeForm from "../../../components/Recipe/RecipeForm";
import { getRecipeById } from "../../../services/recipe.service";
import "../AddRecipe/AddRecipe.css";

export default function EditRecipePage() {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [recipe, setRecipe] = useState(null);

  useEffect(() => {
    const fetchRecipe = async () => {
      try {
        setLoading(true);
        const data = await getRecipeById(id);
        setRecipe(data);
      } catch (err) {
        console.log(err);
        message.error("Failed to load recipe");
      } finally {
        setLoading(false);
      }
    };

    fetchRecipe();
  }, [id]);

  if (loading || !recipe) {
    return (
      <div className="edit-page-loader">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="add-recipe-page">
      <div className="add-recipe-header">
        <Button
          type="link"
          icon={<ArrowLeftOutlined />}
          onClick={() => navigate("/dashboard/recipes")}
          style={{ paddingLeft: 0 }}
        >
          Back to All Recipes
        </Button>
      </div>

      <RecipeForm
        mode="edit"
        initialData={recipe}
        onSuccess={() => navigate("/dashboard/recipes")}
      />
    </div>
  );
}
